import React, { useState } from 'react'
import { TextInput, TextArea, SimpleSelect, FormFieldGroup } from '@instructure/ui'
import ToggleLock from './ToggleLock'
import { emptyRegistration } from "./registrations";

const clientAuthMethods = [
  { id: 'client_secret_basic', name: 'Client Secret Basic' },
  { id: 'client_secret_post', name: 'Client Secret POST' },
  { id: 'none', name: 'None' }
]

const authorizationGrantTypes = [
  { id: 'authorization_code', name: 'Authorization Code' },
  { id: 'implicit', name: 'Implicit' },
  { id: 'refresh_token', name: 'Refresh Token' },
  { id: 'client_credentials', name: 'Client Credentials' },
  { id: 'password', name: 'Password' },
  { id: 'urn:ietf:params:oauth:grant-type:jwt-bearer', name: 'JWT Bearer' }
]

const authMethods = [
  { id: 'header', name: 'Header' },
  { id: 'form', name: 'Form' },
  { id: 'query', name: 'Query' }
]

const EditRegistration = ({ name, disabled, value, onChange }) => {
  const [hideSecret, setHideSecret] = useState(true)
  const editValue = { ...emptyRegistration, ...(value || {}) }

  const updateProviderDetails = (patch) => {
    onChange({
      ...editValue,
      providerDetails: {
        ...(editValue.providerDetails || {}),
        ...patch
      }
    })
  }

  const updateUserInfoEndpoint = (patch) => {
    onChange({
      ...editValue,
      providerDetails: {
        ...(editValue.providerDetails || {}),
        userInfoEndpoint: {
          ...(editValue.providerDetails?.userInfoEndpoint || {}),
          ...patch
        }
      }
    })
  }

  return <FormFieldGroup description={name} disabled={disabled} rowSpacing='small' layout="inline" vAlign="top"
  >
    <TextInput renderLabel='Registration ID'
               disabled={disabled}
               value={editValue.registrationId}
               onChange={(_, registrationId) => onChange({ ...editValue, registrationId })}/>
    <TextInput renderLabel='Client Name'
               disabled={disabled}
               value={editValue.clientName}
               onChange={(_, clientName) => onChange({ ...editValue, clientName })}/>
    <TextInput renderLabel='Client ID'
               disabled={disabled}
               value={editValue.clientId}
               onChange={(_, clientId) => onChange({ ...editValue, clientId })}/>
    <TextInput renderLabel='Client Secret'
               disabled={disabled}
               type={hideSecret ? 'password' : 'text'}
               renderAfterInput={<ToggleLock onChange={setHideSecret}/>}
               value={editValue.clientSecret}
               onChange={(_, clientSecret) => onChange({ ...editValue, clientSecret })}/>
    <SimpleSelect renderLabel='Client Authentication Method'
                  disabled={disabled}
                  value={editValue.clientAuthenticationMethod}
                  onChange={(e, { value: clientAuthenticationMethod }) => onChange({
                    ...editValue,
                    clientAuthenticationMethod
                  })}>
      {clientAuthMethods.map((method, idx) => (
        <SimpleSelect.Option key={idx} id={`opt-${idx}`} value={method.id}>
          {method.name}
        </SimpleSelect.Option>
      ))}
    </SimpleSelect>
    <SimpleSelect renderLabel='Authorization Grant Type'
                  disabled={disabled}
                  value={editValue.authorizationGrantType}
                  onChange={(_e, { value: authorizationGrantType }) => onChange({
                    ...editValue,
                    authorizationGrantType
                  })}>
      {authorizationGrantTypes.map((method, idx) => (
        <SimpleSelect.Option key={idx} id={`opt-${idx}`} value={method.id}>
          {method.name}
        </SimpleSelect.Option>
      ))}
    </SimpleSelect>
    <TextInput renderLabel='Redirect URI'
               disabled={disabled}
               value={editValue.redirectUri}
               onChange={(_, redirectUri) => onChange({ ...editValue, redirectUri })}/>
    <TextArea label='Scopes'
              disabled={disabled}
              value={editValue.scopes?.join('\n')}
              onChange={(e) => onChange({
                ...editValue,
                scopes: e.target.value.trim() === '' ? null : e.target.value.split(/\r?\n/).map(scope => scope.trim())
              })}/>
    <FormFieldGroup description='Provider' rowSpacing='small'>
      <TextInput renderLabel='Authorization URI'
                 disabled={disabled}
                 type='url'
                 value={editValue.providerDetails?.authorizationUri || ''}
                 onChange={(_, authorizationUri) => updateProviderDetails({ authorizationUri })}/>
      <TextInput renderLabel='Token URI'
                 disabled={disabled}
                 type='url'
                 value={editValue.providerDetails?.tokenUri || ''}
                 onChange={(_, tokenUri) => updateProviderDetails({ tokenUri })}/>
      <TextInput renderLabel='JWK Set URI'
                 disabled={disabled}
                 type='url'
                 value={editValue.providerDetails?.jwkSetUri || ''}
                 onChange={(_, jwkSetUri) => updateProviderDetails({ jwkSetUri })}/>
      <TextInput renderLabel='Issuer URI'
                 disabled={disabled}
                 type='url'
                 value={editValue.providerDetails?.issuerUri || ''}
                 onChange={(_, issuerUri) => updateProviderDetails({ issuerUri })}/>
      <FormFieldGroup description='User Info' rowSpacing='small'>
        <TextInput renderLabel='URI'
                   disabled={disabled}
                   type='url'
                   value={editValue.providerDetails?.userInfoEndpoint?.uri || ''}
                   onChange={(_, uri) => updateUserInfoEndpoint({ uri })}/>
        <SimpleSelect renderLabel='Authentication Method'
                      disabled={disabled}
                      value={editValue.providerDetails?.userInfoEndpoint?.authenticationMethod || ''}
                      onChange={(_e, { value: authenticationMethod }) => {
                        updateUserInfoEndpoint({ authenticationMethod })
                      }}>
          <SimpleSelect.Option id='unset' value=''>-- unset-- </SimpleSelect.Option>
          {authMethods.map((method, idx) => (
            <SimpleSelect.Option key={idx} id={`opt-${idx}`} value={method.id}>
              {method.name}
            </SimpleSelect.Option>
          ))}
        </SimpleSelect>
        <TextInput renderLabel='Username Attribute Name'
                   disabled={disabled}
                   value={editValue.providerDetails?.userInfoEndpoint?.userNameAttributeName || ''}
                   onChange={(_, userNameAttributeName) => updateUserInfoEndpoint({ userNameAttributeName })}/>
      </FormFieldGroup>
    </FormFieldGroup>
  </FormFieldGroup>
}

export default EditRegistration
